import * as Yup from 'yup';
import { DateUtil, FormValidationUtil } from '../../../utils';

export const manualPunchIninitialValues = {
  subject: '',
  fromDate: '',
  toDate: '',
  fromTime: '',
  toTime: '',
  comments: '',
  allDay: false,
};

export const manualPunchValidationSchema = Yup.object().shape({
  subject: Yup.string().required('Subject is required'),
  fromDate: Yup.string().required('From date is required'),
  toDate: Yup.string()
    .required('To date is required')
    .test(
      'is-same-as-from-date',
      'To date must be same as From date',
      FormValidationUtil.endDateSameAsStartDate('fromDate'),
    ),
  fromTime: Yup.string()
    .required('From time is required')
    .test(
      'is-before-toTime',
      'From Time must be before To Time',
      FormValidationUtil.fromTimeBeforeToTime('toTime'),
    ),
  toTime: Yup.string()
    .required('To time is required')
    .test(
      'is-after-fromTime',
      'To Time must be after From Time',
      FormValidationUtil.toTimeAfterFromTime('fromTime'),
    ),
  comments: Yup.string(),
});

export const populateFormData = eventInData => {
  const formEditData = {
    subject: eventInData?.Subject,
    fromDate: eventInData?.StartDate
      ? DateUtil.formatDateTimeToHtmlDate(eventInData.StartDate)
      : '',
    toDate: eventInData?.EndDate
      ? DateUtil.formatDateTimeToHtmlDate(eventInData.EndDate)
      : '',
    fromTime: eventInData?.StartTime
      ? DateUtil.formatDateTimetoHtmlTime(eventInData.StartTime)
      : '',
    toTime: eventInData?.EndTime
      ? DateUtil.formatDateTimetoHtmlTime(eventInData.EndTime)
      : '',
    comments: eventInData?.Comments,
    allDay: eventInData?.AllDay,
  };
  return formEditData;
};
